
import { usePromiseTracker } from "react-promise-tracker";

import { ThreeDots } from 'react-loader-spinner';

const Loading = props => {
        const { promiseInProgress } = usePromiseTracker();

        return ( 
            <div>
                {promiseInProgress ?
                    <div
                        style={{
                            width: "100%",
                            height: "100",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center"
                        }}
                    >
                        <ThreeDots color="#00BFFF" height={80} width={80} />
                    </div> : null}
            </div>
        )
    };
    
export default Loading;
